import { render, staticRenderFns } from "./GreyBanner.vue?vue&type=template&id=9792bca8&lang=pug"
import script from "./GreyBanner.vue?vue&type=script&lang=ts"
export * from "./GreyBanner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports